import { c as _c } from "react/compiler-runtime";
import type { CreditCode } from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { creditQueries } from '../api/query';
interface UseCreditInfoOptions {
  enabled?: boolean;
}
export default function useCreditInfo(t0) {
  const $ = _c(14);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    enabled: t2
  } = t1;
  const enabled = t2 === undefined ? true : t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = creditQueries.info();
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== enabled) {
    t4 = {
      ...t3,
      gcTime: Infinity,
      enabled
    };
    $[3] = enabled;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const {
    data: t5,
    isLoading,
    error
  } = useQuery(t4);
  let t6;
  if ($[5] !== t5) {
    t6 = t5 === undefined ? {
      codes: [],
      balance: {
        assigned_amount: 0,
        remaining_amount: 0
      },
      discount_rate: 0,
      plan: "Free"
    } : t5;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const data = t6;
  let t7;
  if ($[7] !== data) {
    t7 = code => data.codes.find(item => item.code === code)?.amounts.find(_temp)?.amount ?? 0;
    $[7] = data;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const getCreditAmount = t7;
  let t8;
  if ($[9] !== data || $[10] !== error || $[11] !== getCreditAmount || $[12] !== isLoading) {
    t8 = {
      data,
      getCreditAmount,
      isLoading,
      error
    };
    $[9] = data;
    $[10] = error;
    $[11] = getCreditAmount;
    $[12] = isLoading;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}
function _temp(item_0) {
  return item_0.unit === "CREDIT";
}